<template>
  <component
    :is="props.useClientLayout ? AdminLayout : PortalLayout"
    section="Reports"
    title="VR Filter Report"
    hideHeader
  >
    <div class="pb-4">
      <BackButton to=".."> Back to Reports List </BackButton>
    </div>
    <div v-if="isPropertyLoading"><Loading /></div>
    <div v-else>
      <h1 class="py-3 mb-6 border-b flex">
        <div class="text-xl">
          <div class="font-bold">VR Filter Report</div>
          <div>
            {{ user.isTenantAdmin ? user.tenantName : property?.name }}
          </div>
        </div>
      </h1>
      <Loading v-if="isReportLoading" />
      <div v-else class="report-container mt-4">
        <div class="flex">
          <div class="flex flex-row gap-2 grow">
            <div v-if="!user.isTenantAdmin" class="basis-1/5">
              <BaseSelect
                defaultText="All Tenants"
                class="px-4 mb-1 text-sm bg-white"
                v-model="filteredTenant"
                :options="tenants"
              />
            </div>
            <div class="basis-1/5">
              <BaseSelect
                defaultText="All Roles"
                class="px-4 mb-1 text-sm bg-white"
                v-model="filteredRole"
                :options="siteRoles"
              />
            </div>
            <div v-if="!props.useClientLayout" class="basis-1/5">
              <BaseCheckbox
                label="Exclude Test Accounts"
                v-model="excludeTestAccounts"
                class="my-4"
              />
            </div>
          </div>
          <BaseButton class="float-right my-1 text-sm ml-2" @click="downloadExcel">
            Export to Excel
          </BaseButton>
        </div>
        <table class="table-auto w-full mt-4 border-2 shadow text-sm">
          <thead class="font-sm font-bold">
            <tr>
              <td class="pl-3 cursor-pointer" @click="ChangeSort(ColumnsToSort.FirstName)">
                First Name
                <UpDownArrow
                  class="float-right"
                  v-if="columnToSort == ColumnsToSort.FirstName"
                  :isUp="!isSortingDown"
                />
              </td>
              <td class="pl-3 cursor-pointer" @click="ChangeSort(ColumnsToSort.LastName)">
                Last Name
                <UpDownArrow
                  class="float-right"
                  v-if="columnToSort == ColumnsToSort.LastName"
                  :isUp="!isSortingDown"
                />
              </td>
              <td class="pl-3 cursor-pointer" @click="ChangeSort(ColumnsToSort.Email)">
                Email
                <UpDownArrow
                  class="float-right"
                  v-if="columnToSort == ColumnsToSort.Email"
                  :isUp="!isSortingDown"
                />
              </td>
              <td
                v-if="filteredTenant == null || filteredTenant.length == 0"
                class="pl-3 cursor-pointer"
                @click="ChangeSort(ColumnsToSort.Tenant)"
              >
                Tenant
                <UpDownArrow
                  class="float-right"
                  v-if="columnToSort == ColumnsToSort.Tenant"
                  :isUp="!isSortingDown"
                />
              </td>
              <!-- <td class="pl-3 py-2 cursor-pointer" @click="ChangeSort(ColumnsToSort.Role)">
              Role
              <UpDownArrow
                class="float-right"
                v-if="columnToSort == ColumnsToSort.Role"
                :isUp="!isSortingDown"
              />
            </td> -->
              <td class="px-3 cursor-pointer" @click="ChangeSort(ColumnsToSort.StartTourDate)">
                Start Tour
                <UpDownArrow
                  class="float-right"
                  v-if="columnToSort == ColumnsToSort.StartTourDate"
                  :isUp="!isSortingDown"
                />
              </td>
              <td class="px-3 cursor-pointer" @click="ChangeSort(ColumnsToSort.EndTourDate)">
                Tour Completed
                <UpDownArrow
                  class="float-right"
                  v-if="columnToSort == ColumnsToSort.EndTourDate"
                  :isUp="!isSortingDown"
                />
              </td>
            </tr>
          </thead>
          <template v-for="(result, i) in filteredvrResultsByUser" :key="i">
            <tr
              class="font-xs font-mono border-bottom-2 hover:border-sky-800 hover:bg-sky-300 cursor-pointer"
              :class="i % 2 ? '' : 'bg-stone-200'"
              @click="selectClick(result)"
            >
              <!-- <td class="pl-3">
                <div class="px-2">
                  <IHeroiconsOutlineChevronUp
                    class="mx-auto"
                    v-if="result.loginEmail === selectedEmail"
                  />
                  <IHeroiconsOutlineChevronDown class="mx-auto" v-else />
                </div>
              </td> -->
              <td class="pl-3">{{ result.firstName }}</td>
              <td class="pl-3">{{ result.lastName }}</td>
              <td class="pl-3">{{ result.loginEmail }}</td>
              <td v-if="filteredTenant == null || filteredTenant.length == 0" class="pl-3">
                {{ result.tenant }}
              </td>
              <!-- <td class="pl-3">{{ result.role }}</td> -->
              <td class="px-3">{{ formatDateTime(result.startTourDate) }}</td>
              <td class="pl-3">{{ formatDateTime(result.endTourDate) }}</td>
            </tr>
            <template v-if="selectedEmail !== '' && result?.loginEmail === selectedEmail">
              <tr>
                <td></td>
                <td :colspan="6">
                  <table class="m-4 table-auto border-2 shadow">
                    <thead class="font-bold">
                      <tr>
                        <td
                          class="pl-8"
                          @click="ChangeDetailsSort(DetailsColumnsToSort.Accomplishment)"
                        >
                          Accomplishment
                          <UpDownArrow
                            class="float-right"
                            v-if="detailsColumnToSort == DetailsColumnsToSort.Accomplishment"
                            :isUp="!isSortingDetailsDown"
                          />
                        </td>
                        <td class="px-8 py-2" @click="ChangeDetailsSort(DetailsColumnsToSort.Date)">
                          Date
                          <UpDownArrow
                            class="float-right"
                            v-if="detailsColumnToSort == DetailsColumnsToSort.Date"
                            :isUp="!isSortingDetailsDown"
                          />
                        </td>
                      </tr>
                    </thead>
                    <tr
                      v-for="(result, i) in sortedSelectedDetailsvrResults"
                      :key="i"
                      class="border-bottom-2"
                      :class="i % 2 ? '' : 'bg-stone-200'"
                    >
                      <td class="pl-8">
                        {{ result.accomplishmentName }}
                      </td>
                      <td class="px-8">
                        {{ formatDateTime(result.dateAccomplished) }}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </template>
          </template>
        </table>
        <div>
          <BaseButton class="float-right my-1 text-sm ml-2" @click="downloadExcel">
            Export to Excel
          </BaseButton>
        </div>
      </div>
    </div>
  </component>
</template>

<script setup lang="ts">
import type { IContent } from "json-as-xlsx";
import * as jsonAsXlsx from "json-as-xlsx";
import PortalLayout from "../../layouts/PortalLayout.vue";
import AdminLayout from "../../layouts/AdminLayout.vue";
import { useBldgStore } from "../../store/bldgStore";
import { VRFilterDetail, VRFilterDTO } from "../../store/generatedFetchClient";
import { useReportStore } from "../../store/reportStore";
import { useUserStore } from "../../store/userStore";
import { NameValue } from "../../sharedTypes";

const bldgStore = useBldgStore();
const reportStore = useReportStore();
const userStore = useUserStore();

const props = withDefaults(defineProps<{ useClientLayout?: boolean }>(), {
  useClientLayout: false,
});

let isStaffUser = ref(false);
var isPropertyLoading = computed(() => bldgStore.isLoading);
var property = computed(() => bldgStore.property);
var user = computed(() => userStore.user);
var tenants = computed<string[]>(() => property.value.tenants.map((t) => t.name));
var siteRoles = computed<NameValue[]>(() =>
  property.value.siteRoles.map(
    (sr) =>
      ({
        name: sr.roleAlias + (sr.isStaffRole ? " (Staff)" : ""),
        value: sr.siteRoleId,
      } as NameValue)
  )
);

var isReportLoading = ref(false);
var vrResultsAll = computed<VRFilterDTO[]>(() => reportStore.vrFilterResults);
var vrResultsByUser = computed<VRFilterDTO[]>(() => {
  let resultsByUser = [] as VRFilterDTO[];

  vrResultsAll.value.forEach((r) => {
    if (!resultsByUser.find((existing) => existing.loginEmail === r.loginEmail))
      resultsByUser.push(r);
  });

  return resultsByUser;
});

var filteredvrResultsByUser = computed<VRFilterDTO[]>(() => {
  let results = vrResultsByUser.value.slice(0) as VRFilterDTO[];
  if (filteredTenant.value != null && filteredTenant.value.length > 0)
    results = results.filter((result) => result.tenant == filteredTenant.value);
  if (filteredRole.value != null && filteredRole.value.length > 0)
    results = results.filter(
      (result) => result.role == getSiteRoleById(parseInt(filteredRole.value))?.roleAlias
    );

  switch (columnToSort.value) {
    case ColumnsToSort.FirstName:
      results = results.sort((a, b) => {
        if (a.firstName == b.firstName) {
          return (a.lastName ?? "").localeCompare(b.lastName ?? "");
        }
        return (a.firstName ?? "").localeCompare(b.firstName ?? "");
      });
      break;
    case ColumnsToSort.LastName:
      results = results.sort((a, b) => {
        if (a.lastName == b.lastName) {
          return (a.firstName ?? "").localeCompare(b.firstName ?? "");
        }
        return (a.lastName ?? "").localeCompare(b.lastName ?? "");
      });
      break;
    case ColumnsToSort.Email:
      results = results.sort((a, b) => (a.loginEmail ?? "").localeCompare(b.loginEmail ?? ""));
      break;
    case ColumnsToSort.Tenant:
      results = results.sort((a, b) => (a.tenant ?? "").localeCompare(b.tenant ?? ""));
      break;
    case ColumnsToSort.Role:
      results = results.sort((a, b) => (a.role ?? "").localeCompare(b.role ?? ""));
      break;
    case ColumnsToSort.StartTourDate:
      results.sort(
        (a, b) => new Date(a.startTourDate).getTime() - new Date(b.startTourDate).getTime()
      );
      break;
    case ColumnsToSort.EndTourDate:
      results.sort((a, b) => new Date(a.endTourDate).getTime() - new Date(b.endTourDate).getTime());
      break;
    case ColumnsToSort.MissionsStartDate:
      results.sort(
        (a, b) => new Date(a.missionsStartDate).getTime() - new Date(b.missionsStartDate).getTime()
      );
      break;
    case ColumnsToSort.MissionsEndDate:
      results.sort(
        (a, b) => new Date(a.missionsEndDate).getTime() - new Date(b.missionsEndDate).getTime()
      );
      break;
  }

  if (isSortingDown.value) {
    results.reverse();
  }

  return results;
});

//Filters
var filteredTenant = ref<string>("");
var filteredRole = ref<string>("");

//Exclude test accounts by default if this is not a staff user
let excludeTestAccounts = ref(!isStaffUser?.value);

enum ColumnsToSort {
  FirstName,
  LastName,
  Email,
  Tenant,
  Role,
  StartTourDate,
  EndTourDate,
  MissionsStartDate,
  MissionsEndDate,
}

var columnToSort = ref<ColumnsToSort>(ColumnsToSort.FirstName);
var isSortingDown = ref<boolean>(true);

function ChangeSort(column: ColumnsToSort) {
  if (column == columnToSort.value) {
    isSortingDown.value = !isSortingDown.value;
  } else {
    columnToSort.value = column;
    isSortingDown.value = true;
  }
}

//For the details sub-table
enum DetailsColumnsToSort {
  Accomplishment,
  Date,
}

var detailsColumnToSort = ref<DetailsColumnsToSort>(DetailsColumnsToSort.Accomplishment);
var isSortingDetailsDown = ref<boolean>(true);

function ChangeDetailsSort(column: DetailsColumnsToSort) {
  if (column == detailsColumnToSort.value) {
    isSortingDetailsDown.value = !isSortingDetailsDown.value;
  } else {
    detailsColumnToSort.value = column;
    isSortingDetailsDown.value = true;
  }

  sortedSelectedDetailsvrResults.value = sortSelectedDetailsvrResults();
}

var sortedSelectedDetailsvrResults = ref<VRFilterDetail[]>([] as VRFilterDetail[]);

function sortSelectedDetailsvrResults() {
  //console.log("Sorting details for email " + selectedEmail.value);
  let results = Object.assign([], vrResultsAll.value) as VRFilterDTO[];
  let selectedPersonDto = results.find((r) => r.loginEmail === selectedEmail.value);
  let selectedResults = selectedPersonDto?.accomplishments ?? ([] as VRFilterDetail[]);

  switch (detailsColumnToSort.value) {
    case DetailsColumnsToSort.Accomplishment:
      selectedResults.sort((a, b) => (a.accomplishmentName > b.accomplishmentName ? -1 : 1));
      break;
    case DetailsColumnsToSort.Date:
      selectedResults.sort(
        (a, b) => new Date(a.dateAccomplished).getTime() - new Date(b.dateAccomplished).getTime()
      );
      break;
  }

  if (isSortingDetailsDown.value) {
    selectedResults.reverse();
  }

  return selectedResults;
}

onMounted(() => {
  excludeTestAccounts.value = !userStore.isStaffUser;
  isStaffUser.value = userStore.isStaffUser;
  loadData();
});
watch(property, loadData);
watch(excludeTestAccounts, loadData);

async function loadData() {
  console.log("Loading vr filter report data...");
  isReportLoading.value = true;
  if (property?.value?.portalId) {
    console.log("Vr Filter report called. Loading filtered VR data...");
    if (props.useClientLayout) excludeTestAccounts.value = true;
    await reportStore.getVRFilterReport(property.value.portalId, excludeTestAccounts.value);
  }

  if (user.value.isTenantAdmin) {
    filteredTenant.value = user.value.tenantName;
  }

  isReportLoading.value = false;
}

let selectedEmail = ref("");
function selectClick(result: VRFilterDTO) {
  // Same item clicked twice => Toggle selection
  selectedEmail.value = result.loginEmail === selectedEmail.value ? "" : result.loginEmail;

  //Changed this to manually set detail results here instead of using computed
  // as a work around for the computed getting called in a loop
  sortedSelectedDetailsvrResults.value = sortSelectedDetailsvrResults();
  console.log("Selected email: " + selectedEmail.value);
}

function formatDateTime(date: any) {
  if (date !== null && date !== undefined) {
    let dd = new Date(date);
    let dateParts = dd.toDateString().split(" ");
    let formatedDate = `${dateParts[1]}  ${dateParts[2]}, ${dateParts[3]}`;
    return formatedDate === "Invalid Date" ? "" : formatedDate;
  }
  return "";
}

function formatDateForExcel(d?: string | number | Date | null) {
  if (d !== null && d !== undefined) {
    var dd = new Date(d);
    if (dd.getFullYear() > 1970) {
      return dd.toLocaleDateString("en-US", {
        month: "numeric",
        day: "numeric",
        year: "numeric",
      });
    }
  }
  return null;
}

function downloadExcel() {
  // Extract the xlsx function from the namespace import
  const xlsx = (jsonAsXlsx as any).default || (jsonAsXlsx as any).xlsx || jsonAsXlsx;

  let data = [
    {
      sheet: "Accomplishments",
      columns: [
        { label: "First Name", value: "firstname" },
        { label: "Last Name", value: "lastname" },
        { label: "Email", value: "email" },
        { label: "Tenant", value: "tenant" },
        { label: "Start Tour", value: "startTourDate" },
        { label: "Tour Completed", value: "endTourDate" },
        { label: "Missions Started", value: "missionsStarted" },
        { label: "Missions Completed", value: "missionsCompleted" },
      ],
      content: [] as IContent[],
    },
  ];

  vrResultsAll.value.map((accomplishment) => {
    data[0].content.push({
      firstname: accomplishment.firstName,
      lastname: accomplishment.lastName,
      email: accomplishment.loginEmail,
      tenant: accomplishment.tenant,
      startTourDate: formatDateForExcel(accomplishment.startTourDate),
      endTourDate: formatDateForExcel(accomplishment.endTourDate),
      missionsStarted: formatDateForExcel(accomplishment.missionsStartDate),
      missionsCompleted: formatDateForExcel(accomplishment.missionsEndDate),
    });
  });

  xlsx(data, {
    fileName:
      "VR_Filter_" +
      property.value.name.replace(" ", "_") +
      "_" +
      new Date(Date.now()).toLocaleDateString("en-US", {
        month: "numeric",
        day: "numeric",
        year: "numeric",
      }),
  });
}

// #region Helpers

var getSiteRoleById = (siteRoleId: number) =>
  property.value?.siteRoles?.find((r) => r.siteRoleId === siteRoleId);

// #endregion Helpers
</script>
